export default "<app-list-api-agencies class=\"flex-column v-100 h-100 flex-grow-1\"></app-list-api-agencies>\n";